import React from "react";
import SupportLayout from "./SupportLayout";
import DriverInterventionsContent from "../admin/components/DriverInterventionsContent";

const DriverInterventionPage = ({ userRole = "SO" }) => {
  return (
    <SupportLayout userRole={userRole}>
      <DriverInterventionsContent useOwnLayout={false} userRole={userRole} />
    </SupportLayout>
  );
};

export default DriverInterventionPage;
